export const RequiredSpan = () => {
  return <span style={{ marginLeft: "3px", color: "red" }}>*</span>;
};
